import { cn } from "@repo/ui/lib/utils";
import type { ReactNode } from "react";

type Align = "left" | "center" | "right";

export default function SectionTitle({
  children,
  align = "center",
  className,
}: {
  children: ReactNode;
  align?: Align;
  className?: string;
}) {
  return (
    <h2
      className={cn(
        "text-xl md:text-3xl lg:text-4xl font-semibold text-primary",
        align === "center" && "text-center",
        align === "left" && "text-center md:text-left",
        align === "right" && "text-right",
        className
      )}
    >
      {children}
    </h2>
  );
}

